import React from "react";

const PAGE_SIZES = [10, 25, 50, 100];

// Shared by the Candidate-wise and Activity-wise tabs. `itemLabel` names what is being counted.
const CandidatesPagination = ({ pagination, totalPages, currentPage, setCurrentPage, pageSize, setPageSize, disabled, itemLabel = "candidates" }) => {
  const renderPages = () => {
    if (totalPages <= 1) return null;
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);
    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(
        <button key={i} className={`page-btn ${currentPage === i ? "active" : ""}`}
          onClick={() => setCurrentPage(i)} disabled={disabled}>{i}</button>
      );
    }
    return (
      <>
        <button className="page-btn" onClick={() => setCurrentPage((p) => p - 1)} disabled={currentPage === 1 || disabled}>‹</button>
        {start > 1 && <span className="page-ellipsis">...</span>}
        {pages}
        {end < totalPages && <span className="page-ellipsis">...</span>}
        <button className="page-btn" onClick={() => setCurrentPage((p) => p + 1)} disabled={currentPage === totalPages || disabled}>›</button>
      </>
    );
  };

  return (
    <div className="pagination-v2">
      <span className="pagination-info-v2">
        {pagination.total > 0 ? (
          <>Showing{" "}
            <strong>{(pagination.page - 1) * pagination.page_size + 1}{" "}–{" "}{Math.min(pagination.page * pagination.page_size, pagination.total)}</strong>{" "}
            of {pagination.total} {itemLabel}</>
        ) : "No results"}
      </span>
      <div className="pagination-controls-v2">{pagination.total > 0 && renderPages()}</div>
      <div className="page-size-select-v2">
        <span>Per page</span>
        <select value={pageSize} onChange={(e) => { setPageSize(parseInt(e.target.value)); setCurrentPage(1); }}>
          {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
    </div>
  );
};

export default CandidatesPagination;
